import { AysVirtualClinic } from '@bindoc-projects/virtual-clinic-domain-lib';
import {
  BD_RESOURCES_LIST_OPTIONS_FILTER_FNC_DEFAULT,
  BdResourcesListConfig,
  BdResourcesSelectInlineConfig,
} from '@bindoc-projects/resource-lib/data';

/**
 * Config for select components.
 *
 * `selectOnInit` - Defines the behavior on init. Only used if virtualClinicId input is empty.
 *                  With `first` the component selects the first item after loading and emits it.
 */

export const AYS_VIRTUAL_CLINIC_LIST_OPTIONS_DISABLE_FNC_DEFAULT = (
  resource: AysVirtualClinic,
) => !resource || resource.hasError;
export const AYS_VIRTUAL_CLINIC_LIST_OPTIONS_DETAIL_LINK_FNC_DEFAULT = (
  resource: AysVirtualClinic,
) => ['/virtual-clinics', resource.id];

export const AYS_VIRTUAL_CLINIC_LIST_OPTION: BdResourcesListConfig = {
  emptyResourcesText: 'Keine Virtellen Kliniken gespeichert',
  disableFnc: AYS_VIRTUAL_CLINIC_LIST_OPTIONS_DISABLE_FNC_DEFAULT,
  detailLinkFnc: AYS_VIRTUAL_CLINIC_LIST_OPTIONS_DETAIL_LINK_FNC_DEFAULT,
  filterFnc: BD_RESOURCES_LIST_OPTIONS_FILTER_FNC_DEFAULT,
};

export const AYS_VIRTUAL_CLINIC_SELECT_OPTIONS_DISABLE_FNC_DEFAULT = () =>
  false;

export const AYS_VIRTUAL_CLINIC_SELECT_OPTIONS_DEFAULT: BdResourcesSelectInlineConfig<AysVirtualClinic> =
  {
    detailLinkFnc: AYS_VIRTUAL_CLINIC_LIST_OPTIONS_DETAIL_LINK_FNC_DEFAULT,
    disableFnc: AYS_VIRTUAL_CLINIC_SELECT_OPTIONS_DISABLE_FNC_DEFAULT,
    filterFnc: BD_RESOURCES_LIST_OPTIONS_FILTER_FNC_DEFAULT,
    resourceNameTitle: 'Virtuelle Klinik',
    emptyResourcesText: 'Keine Virtuellen Kliniken gespeichert',
    selectOnInit: 'first',
    minPermission: 'READ',
    resetOption: false,
  };
